import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Loading indicator. Replaces p-progressSpinner; size is a Tailwind size-* class. */
@Component({
  selector: 'app-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="inline-block animate-spin rounded-full border-2 border-border border-t-brand"
      [class]="size()"
      role="status"
      aria-label="Bezig met laden"
    ></span>
  `,
})
export class SpinnerComponent {
  readonly size = input<string>('size-8');
}
